import { requiredText } from 'src/utils/CommonUtils';
import {
	isAttributeMandatory,
	isDerivedAttribute,
	isEmptyAttributeValue,
	isGlobalAttribute,
} from 'src/utils/attributeTypeUtils';

export const validateTaskDefinition = ({
	taskName,
	comment,
	taskDescription,
	conditionalAttributes,
	taskInputs,
	taskType,
	averageExecutionTime,
}): string[] => {
	const errors: string[] = [];

	if (
		requiredText(taskName) ||
		requiredText(comment) ||
		requiredText(taskDescription)
	) {
		errors.push(
			`Invalid Input values Found in taskName : ${taskName}. Try saving the Task Defintion again`
		);
	}

	if (taskType === 'WaitTask') {
		const { days = 0, hours = 0, minutes = 0 } = averageExecutionTime || {};
		const parts = [days, hours, minutes];

		const hasInvalidPart = parts.some(
			(part) => !Number.isInteger(part) || part < 0
		);

		if (hasInvalidPart) {
			errors.push(
				`Invalid Wait Duration in taskName : ${taskName}. Days, hours and minutes must be non-negative whole numbers`
			);
		} else if (days + hours + minutes <= 0) {
			errors.push(
				`Invalid Wait Duration in taskName : ${taskName}. Set a wait duration greater than zero`
			);
		}
	}

	(conditionalAttributes ?? []).forEach(
		({ operator, attributeName, attributeValue }) => {
			if (!operator || !attributeName || !attributeValue) {
				errors.push(
					`Invalid Input values Found in taskName : ${taskName}. Try Fixing Conditional Attributes`
				);
			}
		}
	);

	// Regex validation on task inputs is intentionally disabled for now;
	// mandatory Global and Derived attributes are only checked for non-empty values.
	(taskInputs ?? []).forEach(({ value, attributeType, attributeName, attributeId, mandatory }) => {
		const isGlobal = isGlobalAttribute({ attributeType });
		const isDerived = isDerivedAttribute({ attributeType });

		if ((!isGlobal && !isDerived) || !isAttributeMandatory({ mandatory })) {
			return;
		}

		if (isEmptyAttributeValue(value)) {
			errors.push(
				`Invalid Input values Found in taskName : ${taskName}. ${
					isDerived ? 'Derived' : 'Global'
				} attribute ${attributeName || attributeId || ''} must not be empty`
			);
		}
	});

	return [...errors];
};
